import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { SearchAreaMasterComponent } from "./search-area-master/search-area-master.component";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  Country,
  District,
  State,
  City,
  area
} from "app/masters/models/branch-master.model";
import { Observable, of } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { LocationService } from "../location.service";

@Component({
  selector: "app-area-master",
  templateUrl: "./area-master.component.html",
  styleUrls: ["./area-master.component.scss"],
})
export class AreaMasterComponent implements OnInit {
  public selectCityObj: any = {};

  selectedCityId: number;
  cityForm: FormGroup;
  activeCountry: Country[] = [];
  activeState: State[] = [];
  activeDistrict: District[] = [];
  activeCity: City[] = [];
  filteredCountryArray: Observable<any[]>;
  filteredStateArray: Observable<any[]>;
  filteredDistrictArray: Observable<any[]>;
  filteredCityArray: Observable<any[]>;
  fkCountryId: FormControl;
  fkStateId: FormControl;
  fkDistrictId: FormControl;
  pkCityId: FormControl;
  countryIndex = [];
  stateIndex = [];
  districtIndex = [];
  cityIndex = [];
  districtLists: any;
  SavingPayLoad: any;
  countryName: string;
  stateName: string;
  districtname: string;
  cityName: string;
  disabled = true;
  popbutton: number;
  enabledisablebtn: boolean = false;
  // getarealistall:any
  private getarealistall: area[] = [];
  countryData: any;
  stateData: any;
  districtData: any;
  cityData: any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AreaMasterComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    public locationService: LocationService
  ) {
    dialogRef.disableClose = true;
    this.getCountryList();
  }

  ngOnInit(): void {
    this.enabledisablebtn = true;
    this.popbutton = 0;
    if (this.data.id != null && this.data.id != undefined) {
      this.popbutton = this.data.id;
    }
    this.loadCityForm();
    this.countryControll();
    this.StateControll();
    this.districtControll();
    this.CityControll();
    this.countryIndex = [];
    this.stateIndex = [];
    this.districtIndex = [];
    this.cityIndex = [];
    this.disabled = true;
    this.getarealistAll();
    // this.getCityListAll();
  }
  closedailog() {
    this.dialogRef.close();
  }

  loadCityForm() {
    this.enabledisablebtn = true;
    this.cityForm = this._fb.group({
      fkCountryId: ['', [Validators.required]],
      fkDistrictId: [{ value: '', disabled: true }, [Validators.required]],
      pkCityId: [{ value: '', disabled: true }, [Validators.required]],
      fkStateId: [{ value: '', disabled: true }, Validators.required],
      isActive: false,
      stateName: '',
      districtname: '',
      countryName: '',
      cityName: '',
      areaName: [{ value: '', disabled: this.disabled }, [Validators.required]],
      pkareaId: 0,
      PinCode: [{ value: '', disabled: this.disabled }, [Validators.required]]
    });
  }

  enableButton($event) {
    const form = this.cityForm.controls;
    if (form.fkCountryId.value == '' || form.fkStateId.value == '' || form.fkDistrictId.value == '' || form.pkCityId.value == '' || form.areaName.value == '' || form.PinCode.value == ''
      || form.PinCode.value == null) {
      this.enabledisablebtn = true;
      if (form.areaName.value !== null && form.areaName.value !== '') {
        this.cityForm.controls.PinCode.enable();
        this.cityForm.patchValue(
          {
            PinCode: '',
          }
        )
      }
    }
    else {
      this.enabledisablebtn = false;
    }
  }

  /* Get Country APi */

  getCountryList() {
    this.locationService.getCountry().subscribe((data) => {
      let countryListActive = data;
      this.countryData = data
      for (var _i = 0; _i < countryListActive.length; _i++) {
        if (countryListActive[_i].isActive == true) {
          this.countryIndex.push(countryListActive[_i]);
          this.activeCountry = this.countryIndex;
        }
      }
      this.countryControll();
    });
  }

  countryControll() {
    this.fkCountryId = new FormControl();
    this.filteredCountryArray = this.fkCountryId.valueChanges.pipe(
      startWith(""),
      map((country) =>
        country
          ? this.filterCountryfunction(country)
          : this.activeCountry.slice()
      )
    );
  }

  filterCountryfunction(name: string) {
    return this.activeCountry.filter(
      (country) =>
        country.countryName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  StateControll() {
    this.fkStateId = new FormControl();
    this.filteredStateArray = this.fkStateId.valueChanges.pipe(
      startWith(""),
      map((State) =>
        State ? this.filterStatefunction(State) : this.activeState.slice()
      )
    );
  }

  filterStatefunction(name: string) {
    return this.activeState.filter(
      (State) => State.stateName.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  districtControll() {
    this.fkDistrictId = new FormControl();
    this.filteredDistrictArray = this.fkDistrictId.valueChanges.pipe(
      startWith(''),
      map((District) =>
        District
          ? this.filterDistrictfunction(District)
          : this.activeDistrict.slice()
      )
    );
  }

  filterDistrictfunction(name: string) {
    return this.activeDistrict.filter(
      (District) =>
        District.districtname.toLowerCase().indexOf(name.toLowerCase()) === 0
    );
  }

  CityControll() {
    this.pkCityId = new FormControl();
    this.filteredCityArray = this.pkCityId.valueChanges.pipe(
      startWith(''),
      map((city) =>
        city ? this.filterCityFunction(city) : this.activeCity.slice()
      )
    );
  }
  filterCityFunction(name: string) {
    return this.activeCity.filter(
      (city) => city.cityName.toLowerCase().indexOf(name.toLowerCase()) == 0
    );
  }


  changeCountry(eventId, isManual: boolean = false) {
    this.enableButton(eventId);
    let selectedCountry = eventId;
    this.stateIndex = [];
    this.activeState = [];
    this.districtIndex = [];
    this.cityIndex = [];
    this.activeDistrict = [];
    this.locationService.getState().subscribe(data => {
      let StateActive = data;
      this.stateData = data
      for (var i = 0; i < StateActive.length; i++) {
        if (StateActive[i].isActive == true && StateActive[i].fkCountryId == selectedCountry) {
          this.stateIndex.push(StateActive[i]);
          this.activeState = this.stateIndex;
          this.cityForm.controls.fkStateId.enable();
        }
      }
      if (isManual) {
        this.StateControll();
        this.cityForm.patchValue(
          {
            fkDistrictId: null,
            pkcityId: null,
            fkStateId: null,
            isActive: false
          });
      }
    });
  }


  changeState(event, isManual: boolean = false) {
    this.enableButton(event);
    let selectStatetId = event;
    this.districtIndex = [];
    this.activeDistrict = []
    this.locationService.getDistrict(0).subscribe(data => {
      let districtList = data;
      this.districtData = data
      for (var i = 0; i < districtList.length; i++) {
        if (districtList[i].isActive == true && districtList[i].fkStateId == selectStatetId) {
          this.districtIndex.push(districtList[i]);
          this.activeDistrict = this.districtIndex;
          this.cityForm.controls.fkDistrictId.enable();
          this.cityForm.controls.pkCityId.enable();
          this.disabled = false;
        }
      }
      if (isManual) {
        this.districtControll();
        this.cityForm.patchValue(
          {
            fkDistrictId: null,
            pkCityId: null,
            isActive: false
          });
      }
    });
  }

  changeDistrict(event, isManual: boolean = false) {
    this.enableButton(event);
    let selectedDistrictId = event;
    this.cityIndex = [];
    this.activeCity = [];

    this.locationService.getCity().subscribe(data => {
      let cityList = data;
      this.cityData = data
      for (var i = 0; i < cityList.length; i++) {
        if (cityList[i].isActive == true && cityList[i].fkDistrictId == selectedDistrictId) {
          this.cityIndex.push(cityList[i]);
          this.cityForm.controls.pkCityId.enable();
          this.activeCity = this.cityIndex
          this.disabled = false;
        }
      }

      if (isManual) {
        this.CityControll();
        this.cityForm.patchValue({
          pkCityId: null,
          isActive: false
        });
      }
    });
  }

  /** Search Area Master */
  searchAreaMaster() {
    const dialogRef = this.dialog.open(SearchAreaMasterComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "80%",
      width: "50%",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.enabledisablebtn = false;
      if (result != null) {
        this.enabledisablebtn = false;
        this.setupdateCityForm(result);
        this.cityForm.controls.areaName.enable();
        this.cityForm.controls.PinCode.enable();
      }
    });


  }

  setupdateCityForm(objdata: any) {
    this.cityForm.patchValue(
      {
        fkDistrictId: objdata.districtname,
        fkCountryId: objdata.countryName,
        fkStateId: objdata.stateName,
        isActive: objdata.isActive,
        pkCityId: objdata.cityName,
        areaName: objdata.areaName,
        pkareaId: objdata.pkAreaId,
        PinCode: objdata.pinCode
      });

    this.changeCountry(objdata.fkCountryId);
    this.changeState(objdata.fkStateId);
    this.changeDistrict(objdata.fkDistrictId);
    this.citySelect(objdata.pkCityId)

  }


  saveCity(event) {
     const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);
    const form = this.cityForm.controls;
    let cityId;
    let districtId;
    let stateId
    let countryname = this.countryData.filter(item => item.countryName == form.fkCountryId.value);
    if (countryname.length == 0) {
      this.locationService.openSnackBar("Please select a valid country", "OK");
      return;
    }
    const cityname = this.cityData.find(item => item.cityName == form.pkCityId.value);
    if (!cityname) {
      this.locationService.openSnackBar("Please select a valid city", "OK");
      return;
    }

    cityId = cityname.pkCityId;
    let districtname = this.districtData.filter(item => item.districtname == form.fkDistrictId.value);
    if (districtname.length == 0) {
      this.locationService.openSnackBar("Please select a valid district", "OK");
      return;
    }
    districtId = districtname[0].pkDistrictId;
    let activeState = this.stateData.filter(item => item.stateName == form.fkStateId.value);
    if (activeState.length == 0) {
      this.locationService.openSnackBar("Please select a valid state", "OK");
      return;
    }
    stateId = activeState[0].pkStateId;

    let filterarray = this.getarealistall.filter(item => item.areaName !== null)
    var areanameData = filterarray.filter(item => item.areaName.toLowerCase() == form.areaName.value.toLowerCase() && item.fkCityId == cityId);
    if (areanameData.length > 0) {
      this.locationService.openSnackBar("Already Exists in  list", "OK");
      this.loadCityForm();
      return
    }

    if (form.pkareaId.value === 0) {
      this.SavingPayLoad = {
        PkAreaId: 0,
        FkDistrictId: districtId,
        isActive: form.isActive.value,
        FkCityId: cityId,
        AreaName: form.areaName.value,
        FkStateId: stateId,
        PinCode: form.PinCode.value
      }
      delete this.SavingPayLoad.pkCityId;
      this.locationService.addareaMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.locationService.openSnackBar("Record Saved Successfully ", "OK");
          this.clearForm();
          this.getarealistAll();
        }
      },
        err => {
          if (err.status == 403) {
            this.locationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.locationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.locationService.openSnackBar("API Failed", "OK");
          }
        }
      );
    } else {
      this.SavingPayLoad = {
        PkAreaId: form.pkareaId.value,
        FkDistrictId: districtId,
        isActive: form.isActive.value,
        FkCityId: cityId,
        AreaName: form.areaName.value,
        FkStateId: stateId,
        PinCode: form.PinCode.value
      }
      this.locationService.addareaMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.locationService.openSnackBar("Record Updated Successfully ", "OK");
          this.clearForm();
        }
      },
        err => {
          if (err.status == 403) {
            this.locationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.locationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.locationService.openSnackBar("API Failed", "OK");
          }
        }
      );
    }
  }


  getarealistAll() {
    this.locationService.getAreaItem(0).subscribe(data => {
      this.getarealistall = [];
      this.getarealistall = data;
      console.log(this.data.length, "lenq")
    })
  }



  citySelect(e) {
    this.enableButton(e);
  }

  changeCity(sid: any, type: any) {
    this.cityForm.controls.areaName.enable();
    this.cityForm.patchValue(
      {
        areaName: '',
        isActive: false
      }
    )

  }

  clearForm() {
    this.cityForm.reset();
    this.disabled = true;
    this.loadCityForm();
    this.countryName = '';
    this.stateIndex = [];
  }


  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

}
